var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.area)?_c('div',[(_vm.area)?_c('photo-gallery',{attrs:{"environnement-type":"area","environnement-object":_vm.area,"gallery-type":"Area","gallery-id":_vm.area.id}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }